import { render, staticRenderFns } from "./custom-button.vue?vue&type=template&id=04720928&scoped=true&"
import script from "./custom-button.vue?vue&type=script&lang=js&"
export * from "./custom-button.vue?vue&type=script&lang=js&"
import style0 from "./custom-button.vue?vue&type=style&index=0&id=04720928&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04720928",
  null
  
)

export default component.exports